module.exports = __webpack_public_path__ + "static/media/15c-01-HOME_ST-2015-126x95cm-oleo-y-aceite-de-lino-sobre-papel.584455d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/15c/15c-01-HOME_ST-2015-126x95cm-oleo-y-aceite-de-lino-sobre-papel.jpg
// module id = 163
// module chunks = 0